import { colorMapper, devices } from "src/styles";
import styled, { css } from "styled-components";

interface SeparatorProps {
  width?: number;
  height?: number;
}

const Separator = styled.div<SeparatorProps>`
  width: 100%;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width * 0.7}px;
    `};

  ${(props) =>
    props.height &&
    css`
      height: ${props.height * 0.7}px;
    `};

  ${devices.tablet} {
    ${(props) =>
      props.width &&
      css`
        width: ${props.width * 0.8}px;
      `};
    ${(props) =>
      props.height &&
      css`
        height: ${props.height * 0.8}px;
      `};
  }

  ${devices.desktop} {
    ${(props) =>
      props.width &&
      css`
        width: ${props.width * 0.9}px;
      `};
    ${(props) =>
      props.height &&
      css`
        height: ${props.height * 0.9}px;
      `};
  }

  ${devices.desktopLarge} {
    ${(props) =>
      props.width &&
      css`
        width: ${props.width}px;
      `};
    ${(props) =>
      props.height &&
      css`
        height: ${props.height}px;
      `};
  }
`;

export const SeparatorWithTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;

  ::before,
  ::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${(props) => props.theme.brandPrimary};
  }

  :not(:empty)::before {
    margin-right: 0.563rem;
  }

  :not(:empty)::after {
    margin-left: 0.563rem;
  }
`;

export const SeparatorText = styled.span`
  padding: 0.313rem;
  color: ${(props) => props.theme.brandPrimary};
  border: 1px solid ${(props) => props.theme.brandPrimary};
  border-radius: 0.438rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SeparatorLine = styled.div<{ color?: string }>`
  width: 100%;
  height: 1px;
  background-color: ${(props) => colorMapper(props, "gray")};
`;

export default Separator;
